import React, { useState } from 'react';
import Header from './header.component';
import Sidebar from './sidebar';
import { Outlet } from 'react-router-dom';
const DashboardLayout = ({ children }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const handleToggleSidebar = () => {
    setSidebarExpanded((prev) => !prev);
  };
  return (
    <div className="container-fluid p-0 overflow-x" >
      <Header onToggleSidebar={handleToggleSidebar} />
      <div className="row flex-nowrap">
        
        <Sidebar expanded={sidebarExpanded} />
        <div className="col py-3">
        <div className={`mt-4 px-3 transition-all ${sidebarExpanded ? 'container ms-md-3 ms-xl-2' : ' ms-2'}`}>
             <Outlet/>
            </div>
         
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;